import axios from "@/lib/axios";

type getNotificationProps = {
  path: string
}
const getNotifications = ({ path }: getNotificationProps) => {
  return axios.get(`/facility/notifications/${path}`);
}

export default getNotifications;